import { logDebug } from "./logger";

let ctx = null;
let unlocked = false;

function getCtx() {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume().catch((err) => logDebug("AudioContext resume failed:", err));
  return ctx;
}

export function unlockSound() {
  if (unlocked) return;
  unlocked = true;
  window.addEventListener("pointerdown", () => {
    try {
      getCtx();
    } catch (err) {
      logDebug("Audio unlock failed:", err);
    }
  }, { once: true });
}

function tone(freq, startOffset, duration, volume = 0.12) {
  const c = getCtx();
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = "sine";
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0, c.currentTime + startOffset);
  gain.gain.linearRampToValueAtTime(volume, c.currentTime + startOffset + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.001, c.currentTime + startOffset + duration);
  osc.connect(gain).connect(c.destination);
  osc.start(c.currentTime + startOffset);
  osc.stop(c.currentTime + startOffset + duration + 0.05);
}

export function playMessageSound() {
  try {
    tone(880, 0, 0.18);
  } catch (err) {
    logDebug("Message sound failed:", err);
  }
}

export function playMentionSound() {
  try {
    tone(660, 0, 0.15);
    tone(990, 0.15, 0.28);
  } catch (err) {
    logDebug("Mention sound failed:", err);
  }
}
